import React from 'react';
import { IFee } from '@mayfield/sanity';
import cn from 'classnames';
import * as styles from './styles.module.scss';

interface IProps extends IFee {}

const Fee = ({ ageGroup, ratePerDay }: IProps) => {
  return (
    <div className={cn('h4', styles.container)}>
      <div>{ageGroup}</div>
      <div>${ratePerDay}</div>
    </div>
  );
};

export default Fee;
